import React from 'react';
import { qs } from 'url-parse';
import type ProjectComponentsType from '@atlassian/jira-spa-apps-project-components/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Match, Query } from '@atlassian/react-resource-router';
import { RedirectToProjectType } from './project-type/index.tsx';

export const LazyProjectComponentsSettings = lazyForPaint<typeof ProjectComponentsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-components", jiraSpaEntry: "async-project-components" */ '@atlassian/jira-spa-apps-project-components'
		),
	),
);

export const SettingsComponentsRedirect = () => {
	const page = (_: Match, { selectedItem, ...rest }: Query) => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
		const querystring = qs.stringify(rest, true);
		return `/settings/components${querystring}`;
	};
	return <RedirectToProjectType page={page} />;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectComponentsSettings}
		pageId="project-settings-components"
		shouldShowSpinner
	/>
);
